import iTimelineBg from "../../../../assets/icons/about-us-page/timeline-bg.svg";
import iTimelinePolaroid1 from "../../../../assets/img/abous-us-page/timeline-polaroid-1.png";
import iTimelinePolaroid2 from "../../../../assets/img/abous-us-page/timeline-polaroid-2.png";
import iTimelinePolaroid3 from "../../../../assets/img/abous-us-page/timeline-polaroid-3.png";
import iTimelinePolaroid4 from "../../../../assets/img/abous-us-page/timeline-polaroid-4.png";
import iTimelinePolaroid5 from "../../../../assets/img/abous-us-page/timeline-polaroid-5.png";
import iTimelinePolaroid6 from "../../../../assets/img/abous-us-page/timeline-polaroid-6.png";
import AboutUsTimelineBlockItem from "./timeline-block-item/timeline-block-item";
import "./timeline-block-list.sass";

const AboutUsTimelineBlockList = () => {
  return (
    <div className="timeline-block-list">
      <AboutUsTimelineBlockItem img={iTimelinePolaroid1} year={"2013"}>
        Год, когда амбиции основателя Ивана превратились в бизнес с чёткими
        принципами.
        <br />
        Запускали первые проекты, когда всё агентство умещалось
        в одном кабинете.
      </AboutUsTimelineBlockItem>

      <AboutUsTimelineBlockItem img={iTimelinePolaroid2} year={"2016"}>
        Появились новые клиенты, проектов стало больше. Начали вкладываться
        в обучение команды, прокачивать экспертизу.
        <br />
        Глобально поменяли подход к работе — внедрили первую CRM, перешли от
        расчетов «на коленке» к учёту в документах и таблицах.
      </AboutUsTimelineBlockItem>

      <AboutUsTimelineBlockItem img={iTimelinePolaroid3} year={"2018"}>
        Период стабильного роста, команда прокачалась — стали браться
        за масштабные задачи.
        <br />
        <br />
        Первые международные проекты: Германия, Индия, Япония, Маврикий.
        Закрепили экспертность в сложных кейсах и выстроили процессы для роста,
        составили грандиозные планы на будущее.
      </AboutUsTimelineBlockItem>

      <AboutUsTimelineBlockItem img={iTimelinePolaroid4} year={"2020"}>
        Сложный этап, но важный урок: выжили и стали сильнее.
        <br />
        <br />
        Объемы существенно снизились, несмотря на обстоятельства, сохранили
        команду и продолжили работу — поддерживали контакты с клиентами,
        проходили обучения, настраивали процессы на будущее.
      </AboutUsTimelineBlockItem>

      <AboutUsTimelineBlockItem img={iTimelinePolaroid5} year={"2022"}>
        Интегрировались в сердце креативного кластера и получили новый виток
        развития — новый офис, новые возможности и доступ к креативу.
        <br />
        Начали работу над имиджем компании — первые победы в профессиональных
        конкурсах и премиях, экспертные статьи в СМИ.
        <br />
        Расширили сервисы и укрепили бренд-позиционирование.
      </AboutUsTimelineBlockItem>

      <AboutUsTimelineBlockItem img={iTimelinePolaroid6} year={"2026"}>
        75 человек и 9 собак, стильный офис и команда, которой доверяют топовые
        клиенты — те самые, о которых мечтали в 2015. Наша автоматизация стала
        отраслевым ориентиром, а корпоративные традиции — от общей ёлки до
        конкурса костюмов на хеллоуин — напоминают, что мы по‑прежнему большая
        семья.
      </AboutUsTimelineBlockItem>

      <img
        src={iTimelineBg}
        className="img-absolute timeline-block-list__bg"
        alt=""
      />
    </div>
  );
};

export default AboutUsTimelineBlockList;
